import { render, staticRenderFns } from "./PaymentNotification.vue?vue&type=template&id=551a098b&scoped=true"
import script from "./PaymentNotification.vue?vue&type=script&lang=js"
export * from "./PaymentNotification.vue?vue&type=script&lang=js"
import style0 from "./PaymentNotification.vue?vue&type=style&index=0&id=551a098b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551a098b",
  null
  
)

export default component.exports